export const activityWidgetScript = 'https://widget.getyourguide.com/dist/pa.umd.production.min.js';
export const hrefUrl = 'https://widget.getyourguide.com/default/activites.frame';
export const partnerId = '3X7MD8B';

export const additionalQueryParams = {
  no: '&lc=c40',
  sv: '&lc=c44',
  da: '&lc=c38',
  fi: '&lc=c25',
};
